import { storeRedux } from 'index';
import { cloneDeep, groupBy, isArray, isEmpty } from 'lodash';
import actions from 'redux/actions';

const { saveLayoutContactGroup } = actions;

//* Default column: https://textback.atlassian.net/browse/TA-11191
const templateColumns = [
  { column: 'First name', value: 'fName', isChecked: true },
  { column: 'Last name', value: 'lName', isChecked: true },
  { column: 'Phone', value: 'phone', isChecked: true },
  { column: 'Carrier', value: 'carrier', isChecked: true },
  { column: 'Language', value: 'language', isChecked: true },
  { column: 'Email', value: 'email', isChecked: true },
  { column: 'Birthday', value: 'dob', isChecked: true },
  { column: 'Address', value: 'address', isChecked: true },
  { column: 'City', value: 'city', isChecked: true },
  { column: 'Zip code', value: 'zipCode', isChecked: true },
  { column: 'State code', value: 'stateCode', isChecked: true },
  { column: 'Phone brand', value: 'phoneBrand', isChecked: true },
  { column: 'Device name', value: 'deviceName', isChecked: true },
  { column: 'OS', value: 'os', isChecked: true },
  { column: 'Web browser', value: 'browser', isChecked: true },
  { column: 'Province state name', value: 'ProvinceStateName', isChecked: false },
  { column: 'Vehicle maker', value: 'vehicleMaker', isChecked: false },
  { column: 'Vehicle model', value: 'vehicleModel', isChecked: false },
  { column: 'Vehicle year', value: 'vehicleYear', isChecked: false },
  { column: 'Vertical', value: 'vertical', isChecked: false },
  { column: 'Phone type', value: 'phoneType', isChecked: false },
  { column: 'IP address', value: 'ip', isChecked: false },
  { column: 'Sub aff1', value: 'Subaff1', isChecked: false },
  { column: 'Sub aff2', value: 'Subaff2', isChecked: false },
  { column: 'Sub aff3', value: 'Subaff3', isChecked: false },
  { column: 'Sub aff4', value: 'Subaff4', isChecked: false },
  { column: 'Sub aff5', value: 'Subaff5', isChecked: false },
  { column: 'Contract', value: 'contract', isChecked: false },
  { column: 'Country', value: 'country', isChecked: false },
  { column: 'EVID', value: 'EVID', isChecked: false },
  { column: 'Gender', value: 'gender', isChecked: false },
  { column: 'Link', value: 'link', isChecked: false },
  { column: 'Name', value: 'name', isChecked: false },
  { column: 'Source', value: 'source', isChecked: false },
  { column: 'Url', value: 'url', isChecked: false },
  { column: 'Phone md5', value: 'phone_md5', isChecked: false },
  { column: 'Device class', value: 'deviceClass', isChecked: false },
  { column: 'Home owner', value: 'home_owner', isChecked: false },
  { column: 'Family status', value: 'family_status', isChecked: false },
  { column: 'Education level', value: 'education_level', isChecked: false },
  { column: 'Job category', value: 'job_category', isChecked: false },
  { column: 'Having children', value: 'having_children', isChecked: false },
  { column: 'Children birthday', value: 'children_birthday', isChecked: false },
  { column: 'Household size', value: 'household_size', isChecked: false },
  { column: 'Dwelling age', value: 'dwelling_age', isChecked: false },
  { column: 'Dwelling type', value: 'dwelling_type', isChecked: false },
  { column: 'Engagement', value: 'engagement', isChecked: false },
  { column: 'Creation date', value: 'creation_date', isChecked: false },
  { column: 'Clicked count', value: 'clicked_count', isChecked: false },
  { column: 'Replied count', value: 'replied_count', isChecked: false },
  { column: 'Converted count', value: 'converted_count', isChecked: false },
  { column: 'Blocked count', value: 'blocked_count', isChecked: false },
  { column: 'Campaign title', value: 'campaignTitle', isChecked: false },
  { column: 'Job title', value: 'jobTitle', isChecked: false },
  { column: 'Credit rating', value: 'creditRating', isChecked: false },
  { column: 'Employer', value: 'employer', isChecked: false },
  { column: 'Contact group name', value: 'contactGroupName', isChecked: false },
  { column: 'Target Number', value: 'targetNumber', isChecked: false },
];

class ColumnContactModel {
  static getDefaultColumns() {
    return templateColumns;
  }

  static sortColumnsByLayout(columns, layout) {
    if (isArray(columns) && !isEmpty(columns) && isArray(layout)) {
      let result = [];
      const layoutCols = layout.filter((el) => el.isChecked === true).map((el) => el.value);
      const groupByAccessor = groupBy(cloneDeep(columns), (el) => layoutCols.includes(el.accessor));

      // const columnsNotExisted = groupByAccessor?.['false'] || [];
      const columnsExisted = groupByAccessor?.['true'] || [];

      const columnsSorted = [];
      for (let i = 0; i < layoutCols.length; i++) {
        const value = layoutCols[i];
        const userFound = columnsExisted.find((el) => el.accessor === value);
        if (userFound) {
          columnsSorted.push(userFound);
        }
      }

      result = [...columnsSorted];
      return result;
    }

    return [];
  }

  static setLayoutToDefault() {
    storeRedux.dispatch(saveLayoutContactGroup({ nextColumns: templateColumns }));
  }

  static async saveLayout(body) {
    try {
      storeRedux.dispatch(saveLayoutContactGroup({ nextColumns: body }));
    } catch (error) {
      alert(JSON.stringify(error));
    }
  }
}

export default ColumnContactModel;
